import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class BusinessType extends Component {

  constructor(props) {
    super(props);
    let businessTypeArray = [];
    if (this.props.role === 'admin') {
      businessTypeArray = [
        { code: 'fleet', name: 'Fleet' },
        { code: 'hireCar', name: 'Hire Car' },
        { code: 'motorCycle', name: 'Motor Cycle' },
        { code: 'smartDrivePrivateCar', name: 'SmartDrive Private Car' },
        { code: 'supremeMotor', name: 'SUPREME Motor' }
      ]
    } else {
      businessTypeArray = [
        { code: 'smartDrivePrivateCar', name: 'SmartDrive Private Car' }
      ]
    }
    this.state = {
      option: [],
      isDataLoaded: false,
      businessTypeArray
    }
  }

  componentWillMount() {

  }

  render() {
    return (
      <FormGroup controlId="businessType">
        <Col componentClass={ControlLabel} sm={5}>
          Business Type *
        </Col>
        <Col sm={7}>
          <select
            className="custom-select"
            id="businessType"
            onChange={this.props.handleChangeBusinessType}
            value={this.props.businessType}
            required
          >
            <option value="">Please select</option>
            {this.state.businessTypeArray.map((obj, index) => {
              const counter = index
              return (
                <option
                  value={obj.code}
                  key={counter}
                >{obj.name}</option>
              );
            })}
          </select>
        </Col>
      </FormGroup>
    )
  }
}

BusinessType.propTypes = {
  handleChangeBusinessType: PropTypes.func,
  businessType: PropTypes.string,
  role: PropTypes.string
};

export default BusinessType;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/businessType/BusinessType.js